import { render, staticRenderFns } from "./ItemEmpleadoExterno.vue?vue&type=template&id=0d2599b5&"
import script from "./ItemEmpleadoExterno.vue?vue&type=script&lang=js&"
export * from "./ItemEmpleadoExterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports